export default {
  language: {
    english: {
      notes: 'English language',
      message: 'English',
    },
    german: {
      notes: 'German language',
      message: 'German',
    },
    spanishChilean: {
      notes: 'Chilean Spanish language',
      message: 'Chilean Spanish',
    },
    finish: {
      notes: 'Finish language',
      message: 'Finish',
    },
    french: {
      notes: 'French language',
      message: 'French',
    },
    portugueseBrazilian: {
      notes: 'Brazilian Portuguese language',
      message: 'Brazilian Portuguese',
    },
    swedish: {
      notes: 'Swedish language',
      message: 'Swedish',
    },
    chineseSimplified: {
      notes: 'Simplified Chinese language',
      message: 'Simplified Chinese',
    },
    russian: {
      notes: 'Russian language',
      message: 'Russian',
    },
  },
  unit: {
    system: {
      metric: {
        notes: 'Metric unit',
        message: 'Metric',
      },
      imperial: {
        notes: 'Imperial unit',
        message: 'Imperial',
      },
    },
    weight: {
      kg: {
        notes: 'Label for unit kilogram',
        message: 'kg',
      },
      g: {
        notes: 'Label for unit gram',
        message: 'g',
      },
      lbs: {
        notes: 'Label for unit pounds',
        message: 'lbs',
      },
      fallbackValue: {
        notes: 'Label when no weight is available',
        message: 'N/A',
      },
    },
    time: {
      second: {
        short: {
          notes: 'Short label unit second',
          message: 'sec',
        },
      },
      minute: {
        short: {
          notes: 'Short label unit minute',
          message: 'm',
        },
      },
      hour: {
        short: {
          notes: 'Short label unit hour',
          message: 'h',
        },
      },
      day: {
        notes: 'Short label for unit day',
        message: {
          one: 'day',
          other: 'days',
        },
      },
      month: {
        notes: 'Short label unit month',
        message: 'Month',
      },
      quarter: {
        notes: 'Short label unit quarter',
        message: 'quarter',
      },
      year: {
        notes: 'Short label unit year',
        message: 'Year',
      },
    },
    day: {
      monday: {
        notes: 'Label for Monday',
        message: 'Monday',
      },
      tuesday: {
        notes: 'Label for Tuesday',
        message: 'Tuesday',
      },
      wednesday: {
        notes: 'Label for Wednesday',
        message: 'Wednesday',
      },
      thursday: {
        notes: 'Label for Thursday',
        message: 'Thursday',
      },
      friday: {
        notes: 'Label for Friday',
        message: 'Friday',
      },
      saturday: {
        notes: 'Label for Saturday',
        message: 'Saturday',
      },
      sunday: {
        notes: 'Label for Sunday',
        message: 'Sunday',
      },
    },
    length: {
      mm: {
        notes: 'Label for millimeter',
        message: 'mm',
      },
      inch: {
        notes: 'Label for inch',
        message: 'in',
      },
    },
    temperature: {
      celsius: {
        notes: 'Label for degree Celsius',
        message: '°C',
      },
      fahrenheit: {
        notes: 'Label for degree Fahrenheit',
        message: '°F',
      },
    },
    power: {
      kW: {
        notes: 'Label for kilowatt',
        message: 'kW',
      },
      hp: {
        notes: 'Label for horsepower',
        message: 'hp',
      },
    },
    pressure: {
      MPa: {
        notes: 'Label for MPa',
        message: 'MPa',
      },
      psi: {
        notes: 'Label for psi',
        message: 'psi',
      },
    },
    angle: {
      degree: {
        notes: 'Label for degree',
        message: '°',
      },
    },
    rotationalSpeed: {
      rpm: {
        notes: 'Label for rotations per minute',
        message: 'rpm',
      },
    },
    level: {
      dB: {
        notes: 'Label for dB',
        message: 'dB',
      },
    },
    acceleration: {
      g: {
        notes: 'Label for g',
        message: 'g',
      },
    },
    ratio: {
      percentagePoint: {
        notes:
          'Label for percentage point unit, used for absolute differences between percentages',
        message: 'pp',
      },
    },
  },
  yes: {
    notes: 'Yes',
    message: 'Yes',
  },
  no: {
    notes: 'No',
    message: 'No',
  },
  notAvailable: {
    notes: 'Not available',
    message: 'N/A',
  },
  and: {
    notes: 'and',
    message: 'and',
  },
  on: {
    notes: 'On',
    message: 'On',
  },
  off: {
    notes: 'Off',
    message: 'Off',
  },
  typeHere: {
    notes: 'Placeholder text for input fields',
    message: 'Type here...',
  },
  error: {
    unauthorized: {
      notes: 'Message shown when user lacks permission to perform an action',
      message: 'Insufficient permissions, please contact your admin.',
    },
    saveDataError: {
      notes: 'Generic error message when unable to save data',
      message: 'Failed to save data.',
    },
  },
  lastModified: {
    notes: 'Last modified date',
    message: 'Last modified',
  },
  notFutureDate: {
    notes: 'Validation error text when selecting a date in the future',
    message: 'Date must be today or before',
  },
  sandvik: {
    notes: 'Sandvik as display name',
    message: 'Sandvik',
  },
  model: {
    createdAt: {
      notes: 'Created date property display name',
      message: 'Created',
    },
    createdBy: {
      notes: 'Created by property display name',
      message: 'Created by',
    },
  },
};
